import { eventPost } from '@/lib/events';
import { currentUpdaterRole } from '@/config/program';

export interface ChatMessageOptions {
  sender_role?: string;
  send_sms?: boolean;
  sent_by_role?: string;
  sent_by?: string | number;
  sent_by_firstname?: string;
  sent_by_lastname?: string;
}

// Tier 4 guards bare sent_by* keys — sender attribution travels in `actor`, the proxy unpacks.
export async function sendChatMessage(
  withingsUserId: string | number,
  message: string,
  options: ChatMessageOptions = {},
): Promise<unknown> {
  const senderRole = options.sender_role ?? currentUpdaterRole();
  const sendSms = options.send_sms ?? false;
  const actorRole = options.sent_by_role ?? currentUpdaterRole();
  const eventType = senderRole === 'patient' ? 'patient_message_sent' : 'careteam_message_sent';
  return eventPost(eventType, {
    id_dev_user: String(withingsUserId),
    message,
    sender_role: senderRole,
    send_sms: sendSms,
    actor: {
      role: actorRole,
      ...(options.sent_by ? { user_id: options.sent_by } : {}),
      ...(options.sent_by_firstname ? { firstname: options.sent_by_firstname } : {}),
      ...(options.sent_by_lastname ? { lastname: options.sent_by_lastname } : {}),
    },
  });
}
